import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Switch from "@mui/material/Switch";
import { fetchPolicyGroupSettings, updatePolicyGroupSetting, updatePolicySettingLock } from "js/Api/index";
import { Button } from '../../../Component/CommonFormEle';
function RecordingSettingsTab({ user, policy, settingsFrom }) {
    const [settings, setSettings] = useState([]);
    const [audioRecording, setAudioRecording] = useState(false);
    const [takeTranscription, setTakeTranscription] = useState(false);

    const updateTakeTranscription = (value) => {
        setTakeTranscription(value)

        if (value === false) 
            setAudioRecording(false)
    }
    
    const [recordingSettingCategoryGroups, setRecordingSettingCategoryGroups] = useState([]);
    const [selectedRecordingOption, setSelectedRecordingOption] = useState("allow");

    const isReadOnly = selectedRecordingOption !== "manage";

    useEffect(() => {
        fetchRecordingSettings();
    }, []);

    const fetchRecordingSettings = async () => {
        try {
            const response = await fetchPolicyGroupSettings(policy.id);

            if (response.success) {
                setSettings(response.data.polictSettings);
                setRecordingSettingCategoryGroups(response.data.policySettingCategoryGroups);
                updateRecordingState(response.data.polictSettings);
                updateSelectedRecordingOption(response.data.policySettingCategoryGroups);
            } else {
                console.error("Failed to fetch Recording settings:", response.error);
            }
        } catch (error) {
            console.error("Error fetching Recording settings:", error);
        }
    };

    const updateRecordingState = (recordingSettings) => {
        recordingSettings.forEach((setting) => {
            if (setting.friendlyName === "settings.call_audio_recording") {
                setAudioRecording(setting.value === "true");
            }
            if (setting.friendlyName === "settings.call_transcription") {
                setTakeTranscription(setting.value === "true");
            }
        });
    };

    const updateSelectedRecordingOption = (categoryGroups) => {
        const recordingCategory = categoryGroups.find(
            (category) => category.categoryName === "Recording Settings"
        );
        if (recordingCategory) {
            setSelectedRecordingOption(recordingCategory.locked ? "manage" : "allow");
        }
    };

    const handleSaveRecordingSettings = async () => {
        // Find the settings we need to update using friendlyName
        const audioRecordingSetting = settings.find(setting =>
            setting.friendlyName === "settings.call_audio_recording"
        );

        const transcriptionSetting = settings.find(setting =>
            setting.friendlyName === "settings.call_transcription"
        );

        // Prepare the settings to update
        const updatedSettings = [];

        // Always update the audio recording setting
        if (audioRecordingSetting) {
            updatedSettings.push({
                ...audioRecordingSetting,
                value: audioRecording.toString()
            });
        }

        // Always update transcription setting (independent of audio recording)
        if (transcriptionSetting) {
            updatedSettings.push({
                ...transcriptionSetting,
                value: takeTranscription.toString()
            });
        }

        try {
            let hasError = false;

            for (const setting of updatedSettings) {
                const response = await updatePolicyGroupSetting(policy.id, setting.id, setting.value);

                if (!response.success) {
                    console.error(`Failed to update setting ${setting.name} (${setting.friendlyName}):`, response.error);
                    hasError = true;
                }
            }

            if (hasError) {
                toast.error("Failed to update Recording settings");
            } else {
                toast.success("Recording settings updated successfully!");
                fetchRecordingSettings();
            }
        } catch (error) {
            console.error("Error updating Recording settings:", error);
            toast.error("Failed to update Recording settings");
        }
    };

    const handleCategoryLockChange = async (locked) => {
        const category = recordingSettingCategoryGroups.find(
            (category) => category.categoryName === "Recording Settings"
        );

        if (!category) return;

        try {
            const response = await updatePolicySettingLock(policy.id, category.id, locked);

            if (response.success) {
                // Update local state
                category.locked = locked;
                setRecordingSettingCategoryGroups([...recordingSettingCategoryGroups]);
                setSelectedRecordingOption(locked ? "manage" : "allow");
            } else {
                console.error("Failed to update category lock:", response.error);
                toast.error("Failed to update category lock");
            }
        } catch (error) {
            console.error("Error updating category lock:", error);
            toast.error("Failed to update category lock");
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h4 className="d-inline">Call Logs</h4>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-3">
                    Transcribe calls as text
                </div>
                <div class="col">
                    <Switch checked={takeTranscription} onChange={(e) => updateTakeTranscription(e.target.checked)} color="primary" disabled={isReadOnly} />
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    Record calls to audio file
                </div>
                <div class="col">
                    <Switch checked={audioRecording} onChange={(e) => setAudioRecording(e.target.checked)} color="primary" disabled={isReadOnly || (takeTranscription === false)} />
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-12">
                    <Button onClick={handleSaveRecordingSettings} variant="black">
                        Apply
                    </Button>
                </div>
            </div>
        </>
    );
}

export default RecordingSettingsTab;